import { useState } from 'react';
import { LocalizedLink as Link } from '../../components/LocalizedLink';
import { useTranslation } from 'react-i18next';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Todos');

  const categories = ['Todos', 'Marketing Digital', 'Trabajo Remoto', 'SEO', 'Cultura Organizacional', 'Tecnología'];

  const blogPosts = [
    {
      id: 1,
      title: 'Bienestar en el trabajo remoto: Ideas para equilibrar la vida laboral y personal, ejercicios de estiramiento o meditación.',
      excerpt: 'Descubre estrategias prácticas para mantener tu salud física y mental mientras trabajas desde casa. Aprende rutinas de estiramiento efectivas y técnicas de meditación.',
      author: 'Liliana Ferro',
      date: '2 de diciembre de 2024',
      readTime: '5 min de lectura',
      category: 'Trabajo Remoto',
      image: '/assets/images/blog/wellness-blog.jpg',
      link: '/blog/wellness-remote-work',
    },
    {
      id: 2,
      title: 'Cómo la Inteligencia Artificial está transformando el Marketing Digital',
      excerpt: 'Explora el impacto revolucionario de la IA en las estrategias de marketing, desde la personalización hasta la analítica predictiva y la creación de contenido automatizado.',
      author: 'Liliana Ferro',
      date: '1 de diciembre de 2024',
      readTime: '7 min de lectura',
      category: 'Marketing Digital',
      image: '/assets/images/blog/ai-marketing-blog.jpg',
      link: '/blog/ai-transforming-marketing',
    },
    {
      id: 3,
      title: 'DE AMARILLO A COOL: El rebranding de Mood',
      excerpt: 'Una inmersión profunda en nuestro viaje de transformación de marca, explorando las decisiones estratégicas detrás de la evolución de nuestra identidad visual y lo que significa para nuestro futuro.',
      author: 'Argenis Leon',
      date: '23 de enero de 2024',
      readTime: '6 min de lectura',
      category: 'Cultura Organizacional',
      image: '/assets/images/blog/rebranding-blog.jpg',
      link: '/blog/rebranding-mood',
    },
    {
      id: 4,
      title: 'Para no expertos: SEO para atraer tráfico web',
      excerpt: 'Una guía para principiantes sobre la optimización en buscadores. Aprende los fundamentos del SEO y cómo mejorar la visibilidad de tu sitio web sin conocimientos técnicos.',
      author: 'Equipo de Marketing',
      date: '23 de octubre de 2024',
      readTime: '8 min de lectura',
      category: 'SEO',
      image: '/assets/images/blog/seo-blog.jpg',
      link: '/blog/seo-for-beginners',
    },
    {
      id: 5,
      title: 'No es otro artículo sobre cultura organizacional',
      excerpt: 'Rompiendo el molde de las discusiones tradicionales sobre cultura corporativa. Información real sobre la construcción de entornos de trabajo auténticos de los que la gente realmente quiera formar parte.',
      author: 'Argenis Leon',
      date: '13 de septiembre de 2024',
      readTime: '6 min de lectura',
      category: 'Cultura Organizacional',
      image: '/assets/images/blog/org-culture-blog.jpg',
      link: '/blog/organizational-culture',
    },
    {
      id: 6,
      title: 'El futuro del diseño web: Tendencias a seguir en 2025',
      excerpt: 'Mantente a la vanguardia con las tendencias emergentes en diseño web. Desde experiencias inmersivas hasta prácticas de diseño sostenibles, descubre qué está dando forma al panorama digital.',
      author: 'Equipo de Diseño',
      date: '15 de noviembre de 2024',
      readTime: '7 min de lectura',
      category: 'Tecnología',
      image: '/assets/images/blog/web-design-blog.jpg',
      link: '/blog/web-design-trends-2025',
    },
    {
      id: 7,
      title: 'Estrategias de Marketing de Contenidos que realmente funcionan',
      excerpt: 'Atraviesa el ruido con tácticas de marketing de contenidos probadas. Aprende cómo crear contenido convincente que resuene con tu audiencia y genere resultados reales.',
      author: 'Equipo de Marketing',
      date: '30 de octubre de 2024',
      readTime: '9 min de lectura',
      category: 'Marketing Digital',
      image: '/assets/images/blog/content-marketing-blog.jpg',
      link: '/blog/content-marketing-strategies',
    },
    {
      id: 8,
      title: 'Construyendo equipos remotos de alto rendimiento',
      excerpt: 'Domina el arte de la gestión de equipos remotos. Consejos prácticos para fomentar la colaboración, mantener la productividad y construir una cultura de equipo sólida a pesar de las distancias.',
      author: 'Liliana Ferro',
      date: '28 de septiembre de 2024',
      readTime: '8 min de lectura',
      category: 'Trabajo Remoto',
      image: '/assets/images/blog/remote-teams-blog.jpg',
      link: '/blog/remote-teams',
    },
    {
      id: 9,
      title: 'SEO Local: Dominando tu mercado geográfico',
      excerpt: 'Desbloquea el poder de la optimización de búsqueda local. Estrategias esenciales para empresas que buscan atraer clientes en su área geográfica inmediata.',
      author: 'Equipo de Marketing',
      date: '19 de agosto de 2024',
      readTime: '7 min de lectura',
      category: 'SEO',
      image: '/assets/images/blog/local-seo-blog.jpg',
      link: '/blog/local-seo',
    },
  ];

  const filteredPosts = selectedCategory === 'Todos' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6">
            Nuestro Blog
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Ideas, historias y experiencia de nuestro equipo. Mantente al día con las últimas tendencias en marketing digital, tecnología y cultura laboral.
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 px-6 bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-emerald-500 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer border border-gray-100"
              >
                <Link to={post.link} className="block">
                  <div className="aspect-[4/3] overflow-hidden w-full h-full">
                    <img
                      src={post.image}
                      alt={post.title}
                      title={post.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="px-3 py-1 bg-emerald-50 text-emerald-600 text-xs font-medium rounded-full whitespace-nowrap">
                        {post.category}
                      </span>
                      <span className="text-xs text-gray-500">{post.readTime}</span>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-emerald-500 transition-colors">
                      {post.title}
                    </h4>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center text-white text-xs font-bold">
                          {post.author.charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <p className="text-xs font-medium text-gray-900">{post.author}</p>
                          <p className="text-xs text-gray-500">{post.date}</p>
                        </div>
                      </div>
                      <i className="ri-arrow-right-line text-emerald-500 text-xl w-6 h-6 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <div className="text-center py-20">
              <i className="ri-file-search-line text-6xl text-gray-300 mb-4 w-16 h-16 flex items-center justify-center mx-auto"></i>
              <p className="text-xl text-gray-500">No posts found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 px-6 bg-gray-900">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Stay Updated
          </h2>
          <p className="text-lg text-gray-300 mb-8">
            Subscribe to our newsletter and never miss our latest insights and updates.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto" data-readdy-form id="blog-newsletter">
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              required
              className="flex-1 px-6 py-4 rounded-full text-sm bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
            <button
              type="submit"
              className="px-8 py-4 bg-emerald-500 text-white text-sm font-medium rounded-full hover:bg-emerald-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
